import { Organization } from '@prisma/client'
import { message } from 'antd'
import { useState } from 'react'
import { useUploadToOrganization } from '~/plugins/upload/client'
import { UIChatAttachment } from '../types'

type Props = {
  organization: Organization
}

export const useAttachments = ({ organization }: Props) => {
  const { mutateAsync: upload } = useUploadToOrganization()

  const [attachments, setAttachments] = useState<UIChatAttachment[]>([])

  const uploadAttachments = async (): Promise<UIChatAttachment[]> => {
    const attachmentsUploaded = []

    try {
      const promises = attachments.map(async attachment => {
        try {
          const response = await upload({
            file: attachment.file,
            organizationId: organization.id,
          })

          if (response.url) {
            attachmentsUploaded.push({
              ...attachment,
              urlPrivate: response.url,
              file: undefined,
            })
          }
        } catch (error) {
          // ignore
        }
      })

      await Promise.all(promises)

      setAttachments(_ => [])

      return attachmentsUploaded
    } catch (error) {
      message.error(`Something went wrong`)
      console.error('Unknown Error', error)

      return []
    }
  }

  return {
    attachments,
    setAttachments,
    uploadAttachments,
  }
}
